import {FCWithHTMLAttributes} from "../types/reactTypes";
import clsMerge from "../util/clsMerge";

/**
 * A higher-order component that adds a default className prop to a component.
 *
 * Usage:
 * 		const StylishComponent = withClassName(Component, "bg-green-500 text-green-400");
 */
const withClassName = <T,>(
	Component: React.ComponentType<T>,
	className: string
) => {
	const WrappedComponent: FCWithHTMLAttributes<T> = (props) => (
		<Component {...props} className={clsMerge(className, props.className)} />
	);
	return WrappedComponent;
};

export default withClassName;
